import i18n from "i18next";
import { faFileInvoice } from "@fortawesome/pro-regular-svg-icons";
import type { AsyncButtonProps } from "src/components/common/buttons/AsyncButton.tsx";
import { AsyncButton } from "src/components/common/buttons/AsyncButton.tsx";
import { useGenericDialog } from "src/components/common/dialogs/GenericDialogContext.ts";
import { ShopOrdersView } from "src/components/views/erp/production/shopOrder/ShopOrdersView.tsx";
import { Permissions } from "src/api/generated/iam/permissions.ts";
import { useHasPermission } from "src/components/views/erp/common/userPermissions.ts";
import { ShopOrderSource } from "src/api/generated/erp/production/shopOrderSource.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface OpenShopOrdersOfSourceButtonProps extends Omit<AsyncButtonProps, "onClick"> {
	shopOrderSource: ShopOrderSource;
}

export const OpenShopOrdersOfSourceButton = ({
	shopOrderSource,
	variant = "menu",
	...props
}: OpenShopOrdersOfSourceButtonProps) => {
	const { openDialog } = useGenericDialog();
	const hasPermission = useHasPermission();

	if (!hasPermission(Permissions.Production.ShopOrders.READ)) return null;

	return (
		<AsyncButton
			label={i18n.t("open_shop_order")}
			icon={faFileInvoice}
			variant={variant}
			onClick={async () => {
				openDialog({
					title: i18n.t("shop_orders"),
					agentContext: {
						key: defineAgentUiContextKey("erp.production.shopOrdersOfSource.dialog"),
						data: {
							sourceId: shopOrderSource.sourceId,
							sourceType: shopOrderSource.sourceType,
						},
						pathSegments: [i18n.t("shop_orders")],
					},
					content: <ShopOrdersView shopOrderSource={shopOrderSource} />,
				});
			}}
			{...props}
		/>
	);
};
